import { createElementBlock as e, openBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, l) {
  return t(), e("svg", n, l[0] || (l[0] = [
    o("path", {
      fill: "currentColor",
      d: "M14.368 1.157a2 2 0 0 1 1.265 0l5 1.666A2 2 0 0 1 22 4.721v15.661a2 2 0 0 1-2.894 1.789l-.553-.277a1 1 0 1 1 .894-1.788l.553.276V4.721l-4-1.334V19.28a2 2 0 0 1-1.367 1.898l-5 1.666a2 2 0 0 1-1.265 0l-5-1.666A2 2 0 0 1 2 19.279V12a1 1 0 1 1 2 0v7.28l5 1.666 5-1.667V3.387l-4 1.334V17a1 1 0 1 1-2 0V4.72L4 3.388V7a1 1 0 1 1-2 0V3.387A2 2 0 0 1 4.632 1.49L9 2.946z"
    }, null, -1)
  ]));
}
const c = { render: r };
export {
  c as default,
  r as render
};
//# sourceMappingURL=ic_map-BL9UDHD0.js.map
